import { Inject, Injectable } from '@angular/core';
import { isNil } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

@Injectable({ providedIn: 'root' })
export class Notifications_ds_get_completed_ordersService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }

  public async get(inParams: { from_date: string, project_id?: number, order_type_id?: number }): 
  Promise<{ result: { Id?: number, LookupCode?: string, OwnerReference?: string, PreferredWarehouseId?: number, ProjectId?: number, ShipmentOrderLookups?: { ShipmentId?: number, Shipment?: { ActualWarehouseId?: number, ExpectedWarehouseId?: number } }[], WarehouseId?: number }[] }> 
  {
    const missingRequiredInParams = [];
    if (isNil(inParams.from_date)) {
      missingRequiredInParams.push('\'from_date\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/Notifications/datasources/ds_get_completed_orders/get`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.$utils.http.post(url, body, options);
    
  }
  public async getList(inParams: { from_date: string, project_id?: number, order_type_id?: number, $top?: number, $skip?: number }): 
  Promise<{ result: { Id?: number, LookupCode?: string, OwnerReference?: string, PreferredWarehouseId?: number, ProjectId?: number, ShipmentOrderLookups?: { ShipmentId?: number, Shipment?: { ActualWarehouseId?: number, ExpectedWarehouseId?: number } }[], WarehouseId?: number }[], totalCount: number }> 
  {
    const missingRequiredInParams = [];
    if (isNil(inParams.from_date)) {
      missingRequiredInParams.push('\'from_date\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/Notifications/datasources/ds_get_completed_orders/getList`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.$utils.http.post(url, body, options);
    
  }
  public async getByKeys(inParams: { from_date: string, project_id?: number, order_type_id?: number, $keys: number[] }): 
  Promise<{ result: { Id?: number, LookupCode?: string, OwnerReference?: string, PreferredWarehouseId?: number, ProjectId?: number, ShipmentOrderLookups?: { ShipmentId?: number, Shipment?: { ActualWarehouseId?: number, ExpectedWarehouseId?: number } }[], WarehouseId?: number }[] }> 
  {
    const missingRequiredInParams = [];
    if (isNil(inParams.from_date)) {
      missingRequiredInParams.push('\'from_date\'');
    }
    if (isNil(inParams.$keys)) {
      missingRequiredInParams.push('\'$keys\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/Notifications/datasources/ds_get_completed_orders/getByKeys`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.$utils.http.post(url, body, options);
    
  }


    
    hasMissingRequiredInParams(inParams: { 
      from_date: string, project_id?: number, order_type_id?: number    }) {
        if(isNil(inParams.from_date)) {
          return true; 
        }
      return false;
    }
}
